package io.eqoty.shared.datalayer.functions

import io.eqoty.shared.datalayer.Repository

suspend fun Repository.getWalletAddress(): String? {
    return web3Provider?.getActiveAccountAddress()
}